export const SENTENCE_NOTES_REQUEST_CONTENT_TYPE = 'text/html';
